import { Injectable } from '@angular/core';

import { Query, gql } from 'apollo-angular';

import { LocalizableNameArgs, UserContext } from '@hdms/shared/common-types';

interface LoggedInContextArgs extends LocalizableNameArgs {
  eVouchersEnabled: boolean;
  isFleetPropEnabled: boolean;
  legacyFleetEnabled: boolean;
  isGlobalAuthorizationManagementEnabled: boolean;
}

export interface LoggedInContextResponse {
  loggedInContext: UserContext;
}

const addressFragment = gql`
  fragment AddressData on Address {
    company
    company2
    formatted(formType: ADDRESS_DISPLAY, localization: $localization)
  }
`;

const accountFragment = gql`
  fragment AccountData on Account {
    id
    originId
    address {
      ...AddressData
    }
    isFleet @include(if: $isFleetPropEnabled)
    isPurchaseOrderNumberMandatory
    isCashOnly
  }
`;

const contactFragment = gql`
  fragment ContactData on Contact {
    id
    email
    originId
    firstName
    lastName
    phone
    title {
      name(localization: $localization)
    }
    function {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class LoggedInContextGqlService extends Query<LoggedInContextResponse, LoggedInContextArgs> {
  override document = gql`
    query GlobalLoggedInContext(
      $localization: LocalizationInput!
      $eVouchersEnabled: Boolean!
      $isFleetPropEnabled: Boolean!
      $legacyFleetEnabled: Boolean!
      $isGlobalAuthorizationManagementEnabled: Boolean!
    ) {
      loggedInContext {
        id
        email
        ... on Customer {
          companyAccount {
            ...AccountData
          }
          contact {
            ...ContactData
          }
          fleetMasterContract(localization: $localization) @include(if: $legacyFleetEnabled) {
            id
            status
          }
          role @include(if: $isGlobalAuthorizationManagementEnabled)
          permissions @include(if: $isGlobalAuthorizationManagementEnabled)
        }
        ... on Employee {
          type
          employeeRole: role @include(if: $eVouchersEnabled) {
            id
            type
            permissions
          }
          customerCompanyAccount {
            ...AccountData
          }
          customerContact {
            ...ContactData
          }
          customerFleetMasterContract(localization: $localization) @include(if: $legacyFleetEnabled) {
            id
            status
          }
        }
      }
    }
    ${accountFragment}
    ${contactFragment}
    ${addressFragment}
  `;
}
